import { PhoneNumberUtil } from 'google-libphonenumber';

const PaymentAPICodes = {
  javascript: `const axios = require('axios');

const options = {
  method: 'POST',
  url: 'https://api-payment-sandbox.vertofx.com/transfer',
  headers: { accept: 'application/json', 'content-type': 'application/json' }
};

axios
  .request(options)
  .then(function (response) {
  })
  .catch(function (error) {
  });`,
  python: `import requests

url = "https://api-payment-sandbox.vertofx.com/transfer"

headers = {
    "accept": "application/json",
    "content-type": "application/json"
}

response = requests.post(url, headers=headers)

print(response.text)`,
};

const FXAPICodes = {
  javascript: `const axios = require('axios');

const options = {
  method: 'POST',
  url: 'https://api-exchange-now-sandbox.vertofx.com/fx/payments/convertWithinWallets',
  headers: { accept: 'application/json', 'content-type': 'application/json' },
  data: { paymentType: 'convertWithinWallets' }
};

axios
  .request(options)
  .then(function (response) {
  })
  .catch(function (error) {
  });`,
  python: `import requests

url = "https://api-exchange-now-sandbox.vertofx.com/fx/payments/convertWithinWallets"

payload = { "paymentType": "convertWithinWallets" }
headers = {
    "accept": "application/json",
    "content-type": "application/json"
}

response = requests.post(url, json=payload, headers=headers)

print(response.text)`,
};

const PBLAPICodes = {
  javascript: `const axios = require('axios');

const options = {
  method: 'GET',
  url: 'https://api-payment-links.vertofx.com.com/12axxxxasdz123a/generate-link',
  headers: { accept: 'application/json' }
};

axios
  .request(options)
  .then(function (response) {
  })
  .catch(function (error) {
  });`,
  python: `import requests

url = "https://api-payment-links.vertofx.com.com/12axxxxasdz123a/generate-link"

headers = { "accept": "application/json" }

response = requests.get(url, headers=headers)

print(response.text)`,
};

const TreasuryAPICodes = {
  javascript: `const axios = require('axios');

const options = {
  method: 'POST',
  url: 'https://api-exchange-now-sandbox.vertofx.com/fx/treasury',
  headers: { accept: 'application/json', 'content-type': 'application/json' },
};

axios
  .request(options)
  .then(function (response) {
  })
  .catch(function (error) {
  });`,
  python: `import requests

url = "https://api-exchange-now-sandbox.vertofx.com/fx/treasury"

headers = {
    "accept": "application/json",
    "content-type": "application/json"
}

response = requests.post(url, json=payload, headers=headers)

print(response.text)`,
};

const MultiCurrencyAccountAPICodes = {
  javascript: `const axios = require('axios');

const options = {
  method: 'GET',
  url: 'https://api-payment-links.vertofx.com.com/multi-currency/accounts',
  headers: { accept: 'application/json' }
};

axios
  .request(options)
  .then(function (response) {
  })
  .catch(function (error) {
  });`,
  python: `import requests

url = "https://api-payment-links.vertofx.com.com/multi-currency/accounts"

headers = { "accept": "application/json" }

response = requests.get(url, headers=headers)

print(response.text)`,
};

const MultiCurrencyWalletsAPICodes = {
  javascript: `const axios = require('axios');

const options = {
  method: 'POST',
  url: 'https://api-payment-sandbox.vertofx.com/multi-currency/wallets',
  headers: { accept: 'application/json', 'content-type': 'application/json' }
};

axios
  .request(options)
  .then(function (response) {
  })
  .catch(function (error) {
  });`,
  python: `import requests

url = "https://api-payment-sandbox.vertofx.com/multi-currency/wallets"

headers = {
    "accept": "application/json",
    "content-type": "application/json"
}

response = requests.post(url, headers=headers)

print(response.text)`,
};

export const codeSnippets = {
  payment: PaymentAPICodes,
  fx: FXAPICodes,
  pbl: PBLAPICodes,
  treasury: TreasuryAPICodes,
  multiCurrencyAccounts: MultiCurrencyAccountAPICodes,
  multiCurrencyWallets: MultiCurrencyWalletsAPICodes,
};

export class Utils {
  private static readonly phoneNumberRegexMapper = new Map<string, RegExp>([
    ['+225', /^(01|07|05)\d{8}$/],
  ]);

  static isValidPhoneNumber(phoneNumber: string): boolean {
    let normalizedPhoneNumber = phoneNumber;
    const pattern = /^\+(\d{1,4})-?(\d+)$/;
    let nationalNumber = '';
    if (/[^\d\-+]/.test(phoneNumber)) {
      return false;
    }
    if (!pattern.test(phoneNumber)) {
      return false;
    }

    const phoneUtil = PhoneNumberUtil.getInstance();
    const parsedNumber = phoneUtil.parse(phoneNumber);
    const countryCode = `+${parsedNumber.getCountryCode()}`;
    nationalNumber = phoneUtil.getNationalSignificantNumber(parsedNumber);
    normalizedPhoneNumber = `${countryCode}-${nationalNumber}`;
    const regex = this.phoneNumberRegexMapper.get(countryCode);
    if (regex) {
      return regex.test(nationalNumber);
    } else {
      try {
        const parsedPhoneNo = phoneUtil.parse(normalizedPhoneNumber);
        const final = phoneUtil.isValidNumber(parsedPhoneNo);
        return final;
      } catch {
        return false;
      }
    }
  }
}
